var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 31.665,
    viewBox: "0 0 40 31.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8304",
    "data-name": "Group 8304",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3929",
    "data-name": "Path 3929",
    d: "M100.18,147.225l6.268,6.885a3.249,3.249,0,0,0,4.511-.01,3.117,3.117,0,0,0,.8-1.377,3.251,3.251,0,0,0,4.195-.29,3.16,3.16,0,0,0,.808-1.375,3.251,3.251,0,0,0,4.191-.292,3.165,3.165,0,0,0,.8-1.345l2.953,2.953a3.191,3.191,0,0,0,4.513-4.511L117.88,136.518l6.726-1.057a3.733,3.733,0,0,0,3.192-3.678,2.5,2.5,0,0,0-2.5-2.5H109.583a9.12,9.12,0,0,0-6.485,2.687l-2.62,2.622a9.155,9.155,0,0,0-.3,12.634Zm1.478-11.458,2.62-2.622a7.46,7.46,0,0,1,5.3-2.2H125.3a.835.835,0,0,1,.833.833,2.065,2.065,0,0,1-1.77,2.032L116,135.128a.833.833,0,0,0-.46,1.412l12.5,12.5a1.524,1.524,0,0,1-2.157,2.153L121,146.3c-.012-.013-.027-.027-.04-.04l-3.407-3.4a.833.833,0,0,0-1.178,1.178l3.435,3.435a1.525,1.525,0,0,1-.038,2.127,1.554,1.554,0,0,1-2.143,0l-1.638-1.64c-.01-.01-.018-.02-.028-.028l-1.74-1.738a.833.833,0,1,0-1.178,1.178l1.76,1.758a1.528,1.528,0,0,1-.032,2.137,1.554,1.554,0,0,1-2.143,0l-1.74-1.747s0,0,0,0l0,0-.007,0a0,0,0,0,0,0,0l0,0,0,0h0a.833.833,0,0,0-1.158,1.2l.1.1a1.524,1.524,0,0,1-.037,2.128,1.579,1.579,0,0,1-2.117.028l-6.24-6.858a7.488,7.488,0,0,1,.243-10.335Z",
    transform: "translate(-97.797 -129.283)",
    fill: "#2f284d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3930",
    "data-name": "Path 3930",
    d: "M344.577,199.734h0l0,0S344.575,199.734,344.577,199.734Z",
    transform: "translate(-331.497 -179.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3931",
    "data-name": "Path 3931",
    d: "M42.739,105.988a7.493,7.493,0,1,0,9.906-9.9.834.834,0,0,0-.687,1.52,5.826,5.826,0,1,1-7.7,7.7.834.834,0,0,0-1.52.685Z",
    transform: "translate(-20.4 -82.079)",
    fill: "#ff5f3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3932",
    "data-name": "Path 3932",
    d: "M.028,66.615A10.827,10.827,0,1,0,13.269,53.372a.791.791,0,0,0-.213-.028.833.833,0,0,0-.213,1.638,9.161,9.161,0,1,1-11.2,11.2A.827.827,0,0,0,.618,65.6.835.835,0,0,0,.028,66.615Z",
    transform: "translate(18.682 -42.998)",
    fill: "#8d79b4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandClick);
export default __webpack_public_path__ + "static/media/hand-click.1a5ab68432ef4ea6d44f9672b93aec27.svg";
export { ForwardRef as ReactComponent };